import { useLocation, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';

const Privacy_policy = ({ companyDetail }) => {


    return (
        <>
            {/* Breadcrumb Section Start */}
            <section className="breadscrumb-section pt-0">
                <div className="container-fluid-lg">
                    <div className="row">
                        <div className="col-12">
                            <div className="breadscrumb-contain">
                                <h2>Privacy Policy </h2>
                                <nav>
                                    <ol className="breadcrumb mb-0">
                                        <li className="breadcrumb-item">
                                            <a href="index-2.html">
                                                <i className="fa-solid fa-house" />
                                            </a>
                                        </li>
                                        <li className="breadcrumb-item active" aria-current="page">
                                            Privacy Policy
                                        </li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* Breadcrumb Section End */}
            {/* 404 Section Start */}
            <section className="section-404 section-lg-space">
                <div className="container-fluid-lg">
                    <div className="row">

                        <div className="col-12 bg-white p-3">

                            <div dangerouslySetInnerHTML={{ __html: companyDetail.company_privacy_policy }} className='editor inter-font'></div>

                            {/* <div>
                                
                                <h5>Welcome to Valorelle! By using our website, you agree to the following terms and conditions. Please read them carefully.</h5>

                                <h3 className='fw-bold inter-font mt-5 mb-2'>1. Use of Our Website</h3>
                                <h5>
                                By accessing our site, you agree not to misuse the content, attempt to harm the site, or infringe on any intellectual property rights. All photos, logos, and text belong to Valorelle and may not be used without permission.
                                </h5>

                                <h3 className='fw-bold inter-font mt-5 mb-2'>2. Product Information</h3>
                                <h5>
                                We aim to display our fragrances and product descriptions as accurately as possible. However, actual scent perception may vary by individual. All prices are subject to change without notice.
                                </h5>
                                
                                <h3 className='fw-bold inter-font mt-5 mb-2'>3. Orders & Payments</h3>
                                <h5>
                                Orders are confirmed upon successful payment. We reserve the right to cancel or refund orders in cases of suspected fraud, unavailability, or technical errors.
                                </h5>
                                
                                <h3 className='fw-bold inter-font mt-5 mb-2'>4. Returns & Refunds</h3>
                                <h5>
                                Please review our full Shipping & Returns Policy for details. Refunds are only accepted within 48 hours of delivery under specific conditions.
                                </h5>
                                
                                <h3 className='fw-bold inter-font mt-5 mb-2'>5. Liability Disclaimer</h3>
                                <h5>
                                While our products are safe for general use, we recommend a patch test for sensitive skin and encourage application on clothing if irritation is a concern. Valorelle is not responsible for individual allergic reactions.
                                </h5>
                                <button
                                    onClick={() => navigate("/")}
                                    className="btn btn-md text-white theme-bg-color mt-4 mx-auto"
                                >
                                    Back To Home
                                </button>
                            </div> */}
                        </div>
                    </div>
                </div>
            </section>
            {/* 404 Section End */}
        </>
    )
}

export default Privacy_policy;